import { Composer } from "./composer";
import { Game } from "./game";
import { Instrument } from "./instrument";
import { Style } from "./style";
import { User } from "./user";

export class Tab {
    id!: number;
    name!: string;
    user!: User;
    game!: Game;
    instruments!: Instrument[];
    styles!: Style[];
    composers!: Composer[];
    average_rating!: number;
    num_ratings!: number;
    user_rating: number | null = null;
    favorited!: boolean;
    created_at!: string;
    created_at_date!: Date;
    slug!: string;
    text!: string;
    replies!: number;
    media_link: string | null = null;
    media_type_: string | null = null;
    views!: number;

    static fromObject(obj: Record<string, any>): Tab {
        const tab = Object.setPrototypeOf(obj, Tab.prototype);
        tab.user = User.fromObject(tab.user);
        tab.game = Game.fromObject(tab.game);
        tab.instruments = tab.instruments.map((obj: any) => Instrument.fromObject(obj));
        tab.styles = tab.styles.map((obj: any) => Style.fromObject(obj));
        tab.composers = tab.composers.map((obj: any) => Composer.fromObject(obj));
        tab.created_at_date = new Date(tab.created_at);
        return tab;
    }
}
